import React from 'react';
import { motion } from 'framer-motion';
import { Download, Search, Zap } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Download className="w-8 h-8 text-navy" data-id="element-64" />,
    title: 'Descarga',
    description: 'Descarga el eBook PDF inmediatamente después de tu compra.'
  }, {
    icon: <Search className="w-8 h-8 text-navy" data-id="element-65" />,
    title: 'Identifica',
    description: 'Identifica tus fugas de energía con nuestra lista de diagnóstico.'
  }, {
    icon: <Zap className="w-8 h-8 text-navy" data-id="element-66" />,
    title: 'Aplica',
    description: 'Aplica el Protocolo de 48 horas y siente cómo la nube se disipa.'
  }];
  return <section className="py-24 bg-cream" data-id="element-67">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-69">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-70">Cómo funciona</h2>
          <div className="w-24 h-1 bg-mint mx-auto" data-id="element-71"></div>
        </motion.div>

        <div className="relative" data-id="element-72">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-mint-dark/30 z-0" data-id="element-73"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-74">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="flex flex-col items-center text-center" data-id="element-75">
                <div className="w-24 h-24 bg-white rounded-full shadow-sm border-4 border-mint-light flex items-center justify-center mb-6 relative" data-id="element-76">
                  <div className="absolute -top-3 -right-3 w-8 h-8 bg-navy text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-77">
                    {index + 1}
                  </div>
                  {step.icon}
                </div>
                <h3 className="text-2xl font-bold mb-4" data-id="element-78">{step.title}</h3>
                <p className="text-navy/70 leading-relaxed max-w-xs" data-id="element-79">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}